import { render } from "./listDetails.vue?vue&type=template&id=4a05cc34&scoped=true"
import script from "./listDetails.vue?vue&type=script&lang=js"
export * from "./listDetails.vue?vue&type=script&lang=js"

import "./listDetails.vue?vue&type=style&index=0&id=4a05cc34&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a05cc34"]])

export default __exports__